/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import { object, string, shape } from 'prop-types';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme) => ({
    promoMessage: {
        height: 'auto',
        borderRadius: '3px',
        border: `1px solid ${theme.palette.cms?.checkbox}`,
        backgroundColor: theme.palette.backToHomeHoverBg,
        color: theme.palette.submit,
        marginBottom: '30px',
        padding: '6px',
        fontFamily: theme.palette.Typography,
    },
    promoMessageImage: {
        width: '100%',
        height: 'auto',
        borderRadius: '3px',
        border: `1px solid ${theme.palette.cms?.checkbox}`,
        margin: '0 auto 30px',
        clear: 'both', // TODO: Remove this when all floats are removed from styles.
    },
    parseMarkPromo: {
        display: 'inline-block',
        marginLeft: '20px',
        cursor: 'pointer',
        textDecoration: 'underline',
        outline: 'none',
    },
    dialogCopy: {
        width: '91%',
    },
    dialogContent: {
        width: '100%',
        display: 'flex',
    },
});

class GraphqlPDPPromotionalBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    render() {
        const { open } = this.state;
        const { promoSummary, classes } = this.props;
        const handleModal = (e, windowOpen) => {
            e.preventDefault();
            e.persist();
            e.stopPropagation();
            this.setState({ open: windowOpen });
        };
        const onClose = () => {
            this.setState({ open: false });
        };
        if (!promoSummary) {
            return null;
        }
        const promoCopy = promoSummary.pdp_message || '';
        const promoCode = promoSummary.promotion_code || '';
        const promoDesc = promoSummary.promotion_details || '';
        const imagePres = promoSummary.image_presentation;
        if (imagePres) {
            return (
                <>
                    <div
                        data-testid="see-promo-details"
                        tabIndex={0}
                        role="link"
                        onKeyDown={() => { }}
                        onClick={(e) => { handleModal(e, true); }}
                    >
                        <img className={classes.promoMessageImage} src={imagePres.url} alt={imagePres.title} />
                    </div>
                    {open ? (
                        <Dialog open={open}>
                            <div className={classes.dialogContent}>
                                <div className={classes.dialogCopy}>
                                    <DialogTitle id="customized-dialog-title">
                                        Details for: <span>{promoCode}</span>
                                    </DialogTitle>
                                </div>
                                <div>
                                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                                        <CloseIcon />
                                    </IconButton>
                                </div>
                            </div>
                            <MuiDialogContent dividers>
                                <Typography gutterBottom>
                                    <ReactMarkdown source={promoDesc} escapeHtml={false} />
                                </Typography>
                            </MuiDialogContent>
                        </Dialog>
                    ) : null}
                </>
            );
        }
        return (
            <>
                <div
                    className={classes.promoMessage}
                >
                    <>
                        <ReactMarkdown
                            escapeHtml={false}
                            renderers={{ root: React.Fragment }}
                            source={promoCopy}
                            disallowedTypes={['paragraph']}
                            unwrapDisallowed
                        />
                        {promoDesc.length ? (
                            <div
                                data-testid="see-promo-details"
                                tabIndex={0}
                                role="link"
                                onKeyDown={() => { }}
                                className={classes.parseMarkPromo}
                                onClick={(e) => { handleModal(e, true); }}
                            >
                                See Details
                            </div>
                        ) : null}
                    </>
                </div>
                {open ? (
                    <Dialog open={open}>
                        <div className={classes.dialogContent}>
                            <div className={classes.dialogCopy}>
                                <DialogTitle id="customized-dialog-title">
                                    Details for: <span>{promoCode}</span>
                                </DialogTitle>
                            </div>
                            <div>
                                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        </div>
                        <MuiDialogContent dividers>
                            <Typography gutterBottom>
                                <ReactMarkdown source={promoDesc} escapeHtml={false} />
                            </Typography>
                        </MuiDialogContent>
                    </Dialog>
                ) : null}
            </>
        );
    }
}

GraphqlPDPPromotionalBlock.propTypes = {
    classes: object.isRequired,
    promoSummary: shape({
        pdp_message: string,
        promotion_code: string,
        promotion_details: string,
    }).isRequired,
};

export default withStyles(styles)(GraphqlPDPPromotionalBlock);
